import React from "react";
import GATSBY_COMPILED_MDX from "/home/venus_builder/venus-ci/workspace/time/master/content/articles/what-is-a-cashiers-check.mdx";
import {graphql} from 'gatsby';
import ArticlePage from '@taboola/venus-core/src/templates/article-template';
ArticlePage
export default function GatsbyMDXWrapper(props) {
  return React.createElement(ArticlePage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const query = graphql`
  query TimeArticlePageQuery($id: String!, $categories: [String!]) {
    relatedArticles: allArticles(
      limit: 4
      filter: {
        frontmatter: {
          type: { eq: "Article" }
          seo: { noindex: { in: [false, null] } }
        }
        fields: { categories: { in: $categories } }
        id: { ne: $id }
      }
        sort: { fields: { dateModified: DESC }}
    ) {
      nodes {
        id
        slug
        frontmatter {
          title
          description
          image {
            alt
            imageFile {
              childImageSharp {
                gatsbyImageData(
                  transformOptions: { cropFocus: ENTROPY }
                  width: 250
                  aspectRatio: 1.5
                )
              }
            }
          }
          type
          authors {
            childMdx {
              slug
              frontmatter {
                name
              }
            }
          }
        }
      }
    }
    relatedAbTests: allAbTestsYaml(
      filter: {
        enabled: { eq: true }
        experiments: {
          elemMatch: {
            experimentDetails: { article: { childMdx: { id: { eq: $id } } } }
          }
        }
      }
    ) {
      nodes {
        originalArticle {
          childMdx {
            slug
          }
        }
      }
    }
    mdx(id: { eq: $id }) {
      slug
      tableOfContents
      timeToRead
      fields {
        dateModified
        datePublished
        useKatex
      }
      frontmatter {
        title
        description
        template
        tags
        publishedAt
        config {
          hideAffiliateLinks
        }
        hero {
          childMdx {
            slug
          }
        }
        seo {
          canonicalSlug
          description
          nofollow
          noindex
          title
          imageFile {
            childImageSharp {
              gatsbyImageData(
                transformOptions: { cropFocus: ENTROPY }
                width: 909
                aspectRatio: 1.66
              )
            }
          }
        }
        image {
          alt
          photographer
          imageSource
          imageFile {
            childImageSharp {
              gatsbyImageData(
                transformOptions: { cropFocus: ENTROPY }
                width: 909
                aspectRatio: 1.66
              )
            }
          }
        }
        authors {
          childMdx {
            slug
            frontmatter {
              name
              socialLinks
              image {
                imageFile {
                  childImageSharp {
                    gatsbyImageData(
                      transformOptions: { grayscale: true }
                      width: 100
                      aspectRatio: 1
                    )
                  }
                }
              }
            }
          }
        }
        editors {
          childMdx {
            slug
            frontmatter {
              name
            }
          }
        }
        categories {
          childMdx {
            slug
            frontmatter {
              name
              parentCategory {
                childMdx {
                  slug
                  frontmatter {
                    name
                  }
                }
              }
            }
          }
        }
        aside {
          textBlock {
            childMdx {
              slug
              frontmatter {
                name
              }
            }
          }
          curatedList {
            childMdx {
              slug
              frontmatter {
                name
                entities {
                  textBlock {
                    childMdx {
                      slug
                      frontmatter {
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
        variants {
          key
          layer
          titleOverride
          imageOverride {
            imageFile {
              childImageSharp {
                gatsbyImageData(
                  transformOptions: { cropFocus: ENTROPY }
                  width: 909
                  aspectRatio: 1.66
                )
              }
            }
          }
        }
      }
    }
    articleData: mdx(id: { eq: $id }) {
      ...ArticleProducts
      ...ArticleCMSProducts
      ...AffiliateLinksQuery
      ...ArticleImages
    }
  }
`;
